/**
 *
 * @author fuyg
 * @date  2020-06-04
 */

import React, { ReactElement /*, useEffect */ } from 'react'
// import { useSelector, useDispatch, shallowEqual } from 'react-redux'
import styles from './StockInfoView.module.scss'
// import { fetchData } from '../sliceName'
// import { RootState } from 'src/pages/home/store/rootReducer'
import { RouteConfigComponentProps, renderRoutes } from 'react-router-config'
import { SideNavigation, NavItem } from 'src/components/SideNavigation'
import shortid from 'shortid'
import routePath from 'src/pages/home/router/routePath'
import { navText } from 'src/utils/navText'

function StockInfoView(props: RouteConfigComponentProps): ReactElement {
  // 获取数据
  // const dispatch = useDispatch()

  // useEffect(() => {
  // dispatch(fetchData({}))
  // }, [])

  // 绑定数据
  // const { data } = useSelector((state: RootState) => {
  // return {
  // data: state.sliceName.data,
  // }
  // }, shallowEqual)

  // TODO
  const navList: NavItem[] = [
    {
      id: shortid.generate(),
      name: navText.stockQuoteChart,
      routeLink: routePath.STOCK_INFO_QUOTE_CHART,
    },
    {
      id: shortid.generate(),
      name: navText.analystConverage,
      routeLink: routePath.STOCK_INFO_ANALYST_COVERAGE,
    },
  ]
  return (
    <div className={styles.container}>
      <div className={styles.nav}>
        <SideNavigation navList={navList} />
      </div>
      <div className={styles.content}>{renderRoutes(props.route?.routes)}</div>
    </div>
  )
}

export default StockInfoView
